import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@store/store';
import { MainParams } from '@api/order-reporting/types-deliveries/DeliveriesParams';
import { DateRange } from '@project-types/DateRange';



export const selectGridData = (state: RootState) => state.reportingDeliveriesMain.gridData;
export const selectDateRange = (state: RootState) => state.reportingDeliveriesMain.dateRange;



export const selectValidParams = createSelector(
	[
		selectDateRange,
	],(
		dateRange: DateRange | null,
	) => {
		if (!dateRange) return null;
		let validParams: MainParams = {
			dateFrom: dateRange.from,
			dateTo: dateRange.to,
		};
		return validParams;
	}
);